import React from "react";
import { Card, Divider, Skeleton } from "@heroui/react";

export default function ProductPageSkeleton() {
  return (
    <div className="space-y-6 md:space-y-10 w-full">
      <div className="flex gap-3 my-4">
        <Skeleton className="rounded-lg">
          <div className="h-3  w-20 bg-default-300 rounded-lg" />
        </Skeleton>
        <Skeleton className="rounded-lg">
          <div className="h-3  w-32  bg-default-300 rounded-lg" />
        </Skeleton>
        <Skeleton className="rounded-lg">
          <div className="h-3 w-40  bg-default-300 rounded-lg" />
        </Skeleton>
      </div>
      <Divider />
      <div className="w-full mx-auto space-y-6 md:space-y-10">
        <Card shadow="none" className="w-full p-4">
          {/* Container for image + text columns */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 xl:gap-6 w-full">
            {/* Left column: product image placeholder */}
            <div className="w-full">
              <Skeleton className="rounded-lg">
                <div className="h-64 lg:h-72 xl:h-80 w-full bg-default-300 rounded-lg" />
              </Skeleton>
            </div>

            {/* Right column: title, product code, description */}
            <div className="w-full space-y-4">
              {/* Product title skeleton */}
              <Skeleton className="rounded-lg w-2/3">
                <div className="h-6 w-2/3 bg-default-200 rounded-lg" />
              </Skeleton>

              {/* Product code skeleton */}
              <Skeleton className="rounded-lg w-1/4">
                <div className="h-4 w-1/4 bg-default-200 rounded-lg" />
              </Skeleton>

              <Divider />
              {/* Description lines skeleton */}
              <Skeleton className="rounded-lg w-full">
                <div className="h-4 w-full bg-default-200 rounded-lg" />
              </Skeleton>
              <Skeleton className="rounded-lg w-full">
                <div className="h-4 w-full bg-default-200 rounded-lg" />
              </Skeleton>
              <Skeleton className="rounded-lg w-3/5">
                <div className="h-4 w-3/5 bg-default-200 rounded-lg" />
              </Skeleton>

              <Skeleton className="rounded-lg w-2/6">
                <div className="h-4 w-2/6 bg-default-200 rounded-lg" />
              </Skeleton>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
